import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchCLReport,
  fetchRPQuickCheck,
} from '~actions'; // eslint-disable-line
import {
  getActiveCompany,
  getQuickCheck,
  getSession,
} from '~selectors'; // eslint-disable-line

// Components
import QuickCheck from './QuickCheck';

const propTypes = {
  company: PropTypes.object.isRequired,
  fetchCLReport: PropTypes.func.isRequired,
  fetchRPQuickCheck: PropTypes.func.isRequired,
  quickCheck: PropTypes.object,
  session: PropTypes.object.isRequired,
};

const defaultProps = {
  quickCheck: undefined,
};

class QuickCheckContainer extends PureComponent {
  componentDidMount() {
    this.props.fetchRPQuickCheck({ company: this.props.company });
  }

  render() {
    return (
      <QuickCheck
        fetchCLReport={this.props.fetchCLReport}
        quickCheck={this.props.quickCheck}
        session={this.props.session}
      />
    );
  }
}

QuickCheckContainer.propTypes = propTypes;
QuickCheckContainer.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    company: getActiveCompany(state),
    quickCheck: getQuickCheck(state, getActiveCompany(state)),
    session: getSession(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchCLReport,
      fetchRPQuickCheck,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps, mapDispatchToProps
)(QuickCheckContainer);
